
import React, { useState } from 'react';
import { signupUser } from '../api';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validate email domain
    if (!email.endsWith('@library.ok')) {
      setErrorMsg("Email must end with @library.ok");
      return;
    }
    signupUser({ email, password })
      .then(res => {
        alert("Signup successful! Please log in.");
        navigate("/login");
      })
      .catch(err => {
        console.error(err);
        setErrorMsg(err.response?.data?.error || "Signup failed");
      });
  };

  return (
    <div className="container">
      <h1>Sign Up</h1>
      {errorMsg && <p className="error">{errorMsg}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input 
            type="email"
            placeholder="yourname@library.ok"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Password:</label>
          <input 
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Sign Up</button>
      </form>
    </div>
  );
};

export default Signup;